const rebateRates = {
    '90210': 0.35,
    '94103': 0.30,
    '10001': 0.28,
};

function showNext(step) {
    const input = document.querySelector(`.step-${step - 1} input`);
    if (input && input.value.trim() !== "") {
        document.querySelector(`.step-${step}`).classList.remove('hidden');
        document.querySelector(`.step-${step}`).classList.add('visible');
    }
}

function formatRebateDollars(amount) {
    const rounded = Math.round(Number(amount) || 0);
    return '$' + rounded.toLocaleString('en-US');
}

function calculateRebate() {
    const zipCode = document.getElementById('zipCode').value.trim();
    const currentLights = parseFloat(document.getElementById('currentLights').value);
    const currentWattage = parseFloat(document.getElementById('currentWattage').value);
    const currentHours = parseFloat(document.getElementById('currentHours').value);
    const ledLights = parseFloat(document.getElementById('ledLights').value);
    const ledWattage = parseFloat(document.getElementById('ledWattage').value);
    const ledHours = parseFloat(document.getElementById('ledHours').value);
    const rebateRate = rebateRates[zipCode] || 0.27;

    const currentAnnualKWh = (currentLights * currentWattage * currentHours * 365) / 1000;
    const ledAnnualKWh = (ledLights * ledWattage * ledHours * 365) / 1000;
    const energySavings = currentAnnualKWh - ledAnnualKWh;
    const rebateAmount = energySavings * rebateRate;

    document.getElementById('rebateAmount').innerText = formatRebateDollars(rebateAmount);
    document.getElementById('rebateResult').classList.remove('hidden');
}

function resetRebateCalculator() {
    const form = document.getElementById('rebateForm');
    if (form) {
        form.reset();
    }
    document.querySelectorAll('.rebate-calculator .step').forEach(function (step, index) {
        step.classList.remove('visible');
        if (index === 0) {
            step.classList.remove('hidden');
        } else {
            step.classList.add('hidden');
        }
    });
    const result = document.getElementById('rebateResult');
    if (result) {
        result.classList.add('hidden');
    }
    const amount = document.getElementById('rebateAmount');
    if (amount) {
        amount.innerText = '$0';
    }
    const zip = document.getElementById('zipCode');
    if (zip) {
        zip.focus();
    }
}
